<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Higienização Agendada</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Nova Higienização"
          icon="assets/add.svg"
          (click)="navegarNovaHigienizacao()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem de Higienizações Agendadas</div>
        <div class="align-button">
          <form [formGroup]="form">
            <div class="table-filters">
              <app-input
                label="Nº Agendamento"
                placeholder="Digite aqui"
                name="FK_AGND"
                formControlName="FK_AGND"
                width="100%"></app-input>
              <app-input
                label="Placa do Cavalo"
                placeholder="Digite aqui"
                name="TX_PLCA_CRRT"
                formControlName="TX_PLCA_CRRT"
                width="100%"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Nº Agendamento"
        placeholder="Digite aqui"
        name="FK_AGND"
        formControlName="FK_AGND"
        width="100%"></app-input>
      <app-input
        label="Placa do Cavalo"
        placeholder="Digite aqui"
        name="TX_PLCA_CRRT"
        formControlName="TX_PLCA_CRRT"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
